import { Button, Modal } from '../../../../components'
import { useAppDispatch } from '../../../../redux/hook'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import { delForm } from '../../api'
import { DelFormProps } from '../type'
import { deleteForm } from '../../slice/formslice'

const DelForm = ({ show, onClose, data }: DelFormProps) => {
    const dispatch = useAppDispatch()
    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title="Delete Form"
            body={
                <>
                    <p className="del-desc">
                        Are you sure you want to delete this Form ?
                    </p>
                    <div className="footer-block">
                        <Button
                            type="submit"
                            onClick={async () => {
                                const response = await delForm(data.id)
                                if (response) {
                                    dispatch(deleteForm({ id: data.id }))
                                    dispatch(
                                        SHOW_NOTIFICATION({
                                            type: 'success',
                                            message:
                                                'Form deleted successfully',
                                        })
                                    )
                                }
                                onClose(false)
                            }}
                        >
                            YES
                        </Button>
                        <Button
                            type="submit"
                            variant="outline-success"
                            onClick={() => onClose(false)}
                        >
                            NO
                        </Button>
                    </div>
                </>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default DelForm
